import type { Theme } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

export default makeStyles((theme: Theme) => ({
  root: {
    width: 260,
    overflow: 'hidden',
  },
  header: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    padding: '6px 6px 0',
    cursor: 'pointer',
    color: theme.palette.text.secondary,
    background: 'none',
    border: 'none',
    textAlign: 'left' as const,
    '&:hover': { color: theme.palette.text.primary },
    '&:focus-visible': {
      outline: `2px solid ${alpha(theme.palette.secondary.main, 0.45)}`,
      outlineOffset: -2,
    },
  },
  headerLabel: {
    fontSize: 12,
    fontWeight: 500,
  },
  inputWrapper: {
    padding: '6px 6px 4px',
  },
  input: {
    fontSize: 12,
    color: theme.palette.text.primary,
    '& .MuiInputBase-input': {
      padding: 0,
      '&::placeholder': {
        color: theme.palette.text.secondary,
        opacity: 1,
      },
    },
  },
  divider: {
    height: 1,
    backgroundColor: theme.palette.divider,
    margin: '4px 4px',
  },
  list: {
    maxHeight: 240,
    overflowY: 'auto',
    padding: 0,
    '&::-webkit-scrollbar': { width: 4 },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: alpha(theme.palette.text.primary, 0.15),
      borderRadius: 2,
    },
  },
  item: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '7px 10px',
    cursor: 'pointer',
    fontSize: 12,
    fontWeight: 500,
    color: theme.palette.text.secondary,
    background: 'none',
    border: 'none',
    borderRadius: 6,
    textAlign: 'left' as const,
    minHeight: 'unset',
    lineHeight: 'normal',
    transition: 'background-color 120ms ease, color 120ms ease',
    '&:hover': {
      backgroundColor: alpha(theme.palette.text.primary, 0.08),
      color: theme.palette.text.primary,
    },
    '&:focus-visible': {
      outline: `2px solid ${alpha(theme.palette.secondary.main, 0.45)}`,
      outlineOffset: -2,
    },
  },
  itemHighlighted: {
    backgroundColor: alpha(theme.palette.text.primary, 0.08),
    color: theme.palette.text.primary,
  },
  itemApplied: {
    color: theme.palette.secondary.main,
    '&:hover': {
      backgroundColor: alpha(theme.palette.secondary.main, 0.08),
    },
  },
  itemLabel: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap' as const,
  },
  itemMeta: {
    fontSize: 11,
    color: theme.palette.text.secondary,
    marginLeft: 8,
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
  },
  loadingRow: {
    display: 'flex',
    justifyContent: 'center',
    padding: '16px 0',
  },
  emptyRow: {
    display: 'flex',
    justifyContent: 'center',
    padding: '12px 0',
  },
}));
